import "./forecast.scss"
import { TextSummaryBase } from "./base"
import { ForecastTextSummary } from "./forecast"

export { TextSummaryBase, ForecastTextSummary }
export default ForecastTextSummary
